import { Log } from '../../log';
import { Sutl } from '../../sutl';
import { ParseError, Parser } from './expression-evaluator';
const debugMacros = false;
const log = Log.channel('RoomMacroParser');
export function evaluateParsedRoomControlCommand(parsedRoomControlCommands, key, roomStates) {
    const ast = parsedRoomControlCommands[key];
    if (ast === undefined) {
        log.error(`interpolated room control command "${key}" not found`);
        return undefined;
    }
    if (ast === null) {
        log.warning(`can't run interpolated room control command "${key}" because it failed to parse`);
        return undefined;
    }
    const scope = {
        round: Math.round,
        states: getValueGetter(roomStates !== null && roomStates !== void 0 ? roomStates : {}, 'states'),
    };
    let roomControlCommand;
    try {
        roomControlCommand = ast.evaluate(scope);
    }
    catch (error) {
        const message = `error evaluating interpolated room control command "${key}": ${error}`;
        log.warning(message);
        return undefined;
    }
    return roomControlCommand;
}
function getValueGetter(obj, fnName) {
    return (path) => {
        if (typeof path !== 'string' && !Array.isArray(path)) {
            if (debugMacros) {
                const pathStr = JSON.stringify(path);
                log.debug(`${fnName}: path = ${pathStr}`);
            }
            throw new Error(`invalid path argument to ${fnName}`);
        }
        const value = Sutl.getProp(obj, path);
        if (debugMacros) {
            const pathStr = JSON.stringify(path);
            const valueStr = JSON.stringify(value);
            log.debug(`${fnName}: path = ${pathStr}, value = ${valueStr}`);
        }
        return value;
    };
}
export function parseInterpolatedRoomControlCommands(macros) {
    var _a;
    const parsedRoomControlCommands = {};
    for (const macro of Object.values(macros)) {
        for (const [key, action] of Object.entries((_a = macro.actions) !== null && _a !== void 0 ? _a : {})) {
            if (action.type !== 'interpolatedRoomControlCommand')
                continue;
            const parser = new Parser(action.command);
            let ast;
            try {
                ast = parser.parse();
                parsedRoomControlCommands[key] = ast;
            }
            catch (error) {
                let message = `error parsing interpolated room control command in macro ${macro.name}, ` +
                    `action key = "${key}", action index = ${action.index}`;
                if (error instanceof ParseError) {
                    message += `: ${error.message} at position ${error.position}`;
                }
                else {
                    message += `: ${error}`;
                }
                log.error(message);
                parsedRoomControlCommands[key] = null;
            }
        }
    }
    return parsedRoomControlCommands;
}
